import { comparer, computed, makeObservable } from 'mobx';

import type { IChartDataModel } from '../../../layers/model';
import type { IPresenter } from '../../../layers/presenter';

export class DataItemsCompactPresenter<TData> implements IPresenter<TData, number> {
  private readonly dataModel: IChartDataModel<TData>;

  constructor(dataModel: IChartDataModel<TData>) {
    this.dataModel = dataModel;

    makeObservable(this);
  }

  @computed({ equals: comparer.shallow })
  get data(): TData {
    return this.dataModel.data;
  }
}
